import productBasedCollectionPage from "@faire/web-api--source/routes/product-based-collection/product_based_collection_token";

/**
 * Builds a product based collection page url.
 * @param productBasedCollectionToken
 * @returns page url
 */
export const getProductBasedCollectionLinkTo = (
  productBasedCollectionToken: string | undefined
): string =>
  productBasedCollectionToken
    ? productBasedCollectionPage(productBasedCollectionToken)
    : "";
